/* Unsplash.js */

import axios from 'axios';

const PZ_UNSPLASH_API = process.env.REACT_APP_PZ_UNSPLASH_API;
const PZ_UNS_KEY = process.env.REACT_APP_PZ_UNS_KEY;
const api = axios.create();
const _timestamp = () => Math.floor(Date.now() / 1000);

const Unsplash = {
  getRandomPhotos: async (count = 10) => {
    const _t = _timestamp();
    const url = `${PZ_UNSPLASH_API}?PLUGIN_KEY=${PZ_UNS_KEY}&method=random&count=${count}&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  queryPhotos: async (query, count = 12) => {
    const _t = _timestamp();
    const url = `${PZ_UNSPLASH_API}?PLUGIN_KEY=${PZ_UNS_KEY}&method=search&query=${query}&per_page=${count}&page=1&_=${_t}`;

    return new Promise((resolve, reject) => {
      api({
        method: 'GET',
        url: url,
      })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  }

};

export default Unsplash;
